import { SearchService } from '@aipb/gulliver/catalog/data-access';
import { PreparedQueryModel, SearchTab } from '@aipb/gulliver/catalog/model';
import { CatalogRouting } from '@aipb/gulliver/catalog/routing';
import { CatalogGoogleAnalyticsService } from '@aipb/gulliver/util-google-analytics';
import { UseCase } from '@aipb/shared/util/usecase';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchUseCase implements UseCase<PreparedQueryModel> {
  private searchService = inject(SearchService);
  private catalogRouting = inject(CatalogRouting);
  private catalogGa = inject(CatalogGoogleAnalyticsService);

  execute(data: PreparedQueryModel) {
    const tabParams: SearchTab = {
      solrSearchParams: {
        query: data.query
      },
      settings: {}
    };
    if (data.coordinates) {
      tabParams.coordinates = data.coordinates.split(',').map(Number);
      tabParams.solrSearchParams.spatialFilter = {
        spatialType: 'rectangle',
        spatialField: 'Coordinates',
        rectangle: data.coordinates
      };
    }

    this.searchService.addTab(tabParams, true);
    this.catalogGa.PREPREPARED_QUERY.search(data.query);
    this.catalogRouting.searchResult();
  }
}
